<template>
    <div class="home">
        <div class="banners owl-carousel" >
            <div class="item right" style="background-image:url('/static/img/baner/baner1.jpg')">
                <div class="container">
                    <div class="text">
                        Judaszowce, lecz nie tylko ...
                    </div>
                </div>

            </div>
            <div class="item left" style="background-image:url('/static/img/baner/baner2.jpg')">
                <div class="container">
                    <div class="text">
                        Judaszowce, lecz nie tylko ...
                    </div>
                </div>

            </div>
            <div class="item right" style="background-image:url('/static/img/baner/baner3.jpg')">
                <div class="container">
                    <div class="text">
                        Judaszowce, lecz nie tylko ...
                    </div>
                </div>
            </div>
            <div class="item right" style="background-image:url('/static/img/baner/baner4.jpg')">
                <div class="container">
                    <div class="text">
                        Judaszowce, lecz nie tylko ...
                    </div>
                </div>
            </div>
            <div class="item right" style="background-image:url('/static/img/baner/baner5.jpg')">
                <div class="container">
                    <div class="text">
                        Judaszowce, lecz nie tylko ...
                    </div>
                </div>
            </div>
            <div class="item right" style="background-image:url('/static/img/baner/baner6.jpg')">
                <div class="container">
                    <div class="text">
                        Judaszowce, lecz nie tylko ...
                    </div>
                </div>
            </div>

        </div>
        <div class="ofertaHome">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="pageHeader text-center">
                            Witamy na stronie naszej Szkółki Olszewscy
                        </div>
                        <div class="cms text-center">
                            Produkcją szkółkarską zajmujemy się od 1988 roku.<br/>
                            <br/>
                            Trzonem naszej produkcji jest obecnie pojemnikowa uprawa drzew do nasadzeń alejowych i ogrodowych w wielkościach od 2-3 letnich szczepów do 12-14cm obwodu. Poza drzewami uprawiamy wiele gatunków i odmian krzewów liściastych i iglastych, bylin oraz pnączy.<br/>
                            <br/>
                            Jednak znakiem rozpoznawczym naszej szkółki są z pewnością Judaszowce kanadyjskie (Cercis canadensis). Kilka lat temu rozpoczęliśmy u nas proces uprawy i popularyzacji w Polsce tych pięknych i oryginalnych roślin. Obecnie polecamy do sadzenia w polskich ogrodach dziesięć sprawdzonych przez nas, najcenniejszych naszym zdaniem odmian.<br/>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-md-center justify-content-lg-center">
                    <div class="col-12 col-md-6  col-lg-4">
                        <router-link
                                class="item"
                                :to="'/judaszowce-cercises'">
                            <div class="img">
                                <img class="img-fluid" src="/static/img/judaszowce.jpg" alt="Judaszowce Cercises"/>
                            </div>
                            <div class="text">
                                Judaszowce Cercises
                            </div>

                        </router-link>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <router-link
                                class="item"
                                :to="'/szpalery-formowane'">
                            <div class="img">
                                <img class="img-fluid" src="/static/img/szpalery.jpg" alt="Szpalery formowane"/>
                            </div>
                            <div class="text">
                                Szpalery formowane
                            </div>

                        </router-link>
                    </div>
                    <div class="col-12  col-md-6 col-lg-4">
                        <router-link
                                class="item"
                                :to="'/asortyment'">
                            <div class="img">
                                <img class="img-fluid" src="/static/img/asortyment.jpg" alt="Asortyment"/>
                            </div>
                            <div class="text">
                                Asortyment
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="ofertaInfo">
                            Zapraszamy do współpracy odbiorców hurtowych.<br/>
                            Dla klientów indywidualnych mamy na terenie szkółki punkt sprzedaży detalicznej.
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="infoBox">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <div class="item">
                            <div class="boxIcon">
                                <span class="icon-pin1"></span>
                            </div>
                            <div class="text">
                                ul. Strażacka 20<br/>
                                42-262 Poczesna
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="item">
                            <div class="boxIcon">
                                <span class="icon-clock1"></span>
                            </div>
                            <div class="text">
                               poniedziałek - piątek<br/>
                                9.00 - 18.00
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="item l">
                            <div class="boxIcon">
                                <span class="icon-clock1"></span>
                            </div>
                            <div class="text">
                                sobota<br/>
                                9.00 - 14.00
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="sloganHome">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="ofertaInfo">
                            Zapraszamy wszystkich do odwiedzin naszego stoiska na corocznej, międzynarodowej wystawie<br/>"Zieleń to Życie", odbywającej się w Warszawie początkiem września każdego roku.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="opisHome">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="item">
                            <div class="imgBig">
                                <img class="img-fluid" src="/static/img/medale/1_big.jpg" alt="Cercis canadensis 'THE RISING SUN'"/>
                            </div>
                            <div class="imgSmall">
                                <img class="img-fluid" src="/static/img/medale/1_small.jpg" alt="Cercis canadensis 'THE RISING SUN'"/>
                            </div>
                            <div class="text">
                                Na 26 edycji tych targów we wrześniu 2018 roku, zaprezentowana przez nas roślina znalazła uznanie w oczach jury i została w "Konkursie Nowości" uhonorowana srebrnym medalem. Był to Judaszowiec kanadyjski 'THE RISING SUN' (Cercis canadensis 'THE RISING SUN')
                            </div>
                        </div>
                        <div class="item">
                            <div class="imgBig">
                                <img class="img-fluid" src="/static/img/medale/2_big.jpg" alt="Cercis canadensis 'Pim Pom Poms'"/>
                            </div>
                            <div class="imgSmall">
                                <img class="img-fluid" src="/static/img/medale/2_small.jpg" alt="Cercis canadensis 'Pim Pom Poms'"/>
                            </div>
                            <div class="text">
                                W poprzednich edycjach konkursu zgłoszone przez nas rośliny również otrzymywały medale. W 2016 roku był to Judaszowiec kanadyjski 'PINK POM POMS' (Cercis canadensis 'Pim Pom Poms'), zdobył on srebrny medal.
                            </div>
                        </div>
                        <div class="item">
                            <div class="imgBig">
                                <img class="img-fluid" src="/static/img/medale/3_big.jpg" alt="Campsis xtagliabuana 'SUMMER JAZZ FIRE'"/>
                            </div>
                            <div class="imgSmall">
                                <img class="img-fluid" src="/static/img/medale/3_small.jpg" alt="Campsis xtagliabuana 'SUMMER JAZZ FIRE'"/>
                            </div>
                            <div class="text">
                                W 2015 roku kolejna nasza nowość, pnącze - Milin 'SUMMER JAZZ FIRE'-'Takarazuka Fresa'(Campsis xtagliabuana 'SUMMER JAZZ FIRE'  tym razem to złoty medal.
                            </div>
                        </div>
                        <div class="item">
                            <div class="imgBig">
                                <img class="img-fluid" src="/static/img/medale/4_big.jpg" alt="'LAVENDER TWIST'  (Cercis canadensis Lavender Twist)"/>
                            </div>
                            <div class="imgSmall">
                                <img class="img-fluid" src="/static/img/medale/4_small.jpg" alt="'LAVENDER TWIST'  (Cercis canadensis Lavender Twist)"/>
                            </div>
                            <div class="text">
                                Kolejny złoty medal na wystawie w tym samym roku otrzymała zgłoszona przez nas nowość; Judaszowiec kanadyjski 'LAVENDER TWIST'  (Cercis canadensis Lavender Twist).  Medal ten przyznany został przez czytelników znanego  internetowego portalu dla ludzi kochających zieleń "Tomek Ogrodnik" - dziękujemy.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>

    import 'owl.carousel/dist/owl.carousel.js'
    import 'owl.carousel/dist/assets/owl.carousel.min.css'
    import 'owl.carousel/dist/assets/owl.theme.default.min.css'

    export default {
        components: {

        },
        methods: {
            installOwlCarousel: function () {
               var owl = $('.banners').owlCarousel({
                    items: 1,
                    loop: true,
                    dots:true,
                    arrow:false,
                    autoplay:true,
                   onInitialized:  function () {
                       $('.banners .owl-dots').addClass('container');
                   },
                   responsive:{
                        0 :{
                            dots:true
                        },
                        767 :{
                            dots:true
                        }
                    }
                });


            }

        },
        mounted: function () {
            this.$nextTick(function () {
                this.installOwlCarousel()
            });

        }
    }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue